const sidebarEntry = {
    label: 'Sidebar Entry',
    name: 'sidebar_entry',
    widget: 'object',
    i18n: true,
    fields: [
        {
            label: 'Category',
            name: 'category',
            widget: 'string',
            required: true,
            i18n: true,
        },
        {
            label: 'Priority',
            name: 'priority',
            widget: 'number',
            required: true,
            i18n: true,
        },
    ],
}


export default {
    name: "blog",
    label: "Blogi",
    label_singular: 'Postitus',
    extension: "mdx",
    format: "frontmatter",
    folder: "src/content/docs/",
    create: true,
    delete: true,
    i18n: {
        structure: "multiple_folders",
    },
    fields : [
        {
            label: "Title",
            name: "title",
            widget: "string",
            required: true,
            i18n: true,
        },
        {
            label: "Description",
            name: "description",
            widget: "text",
            required: true,
            i18n: true,
        },
        {
            label: "PostId",
            name: "postId",
            widget: "uuid",
            required: true,
            i18n: 'duplicate',
        },
        {
            label: "PostSlug",
            name: "postSlug",
            widget: "string",
            required: true,
            i18n: true,
        },
        {
            label: "Locale",
            name: "locale",
            widget: "hidden",
            default: "{{locale}}",
            i18n: true,
        },
        sidebarEntry,
        {
            label: "Body",
            name: "body",
            widget: "markdown",
            required: true,
            i18n: true,
        }
    ],
}